export const AUTH_TOKEN = '/get-auth-token';
export const USER_DEVICES = '/user/devices';
export const SUBSCRIPTION = '/asset/{0}/subscription';
export const DEVICE_INFO = '/asset/{0}/device/actions/getDeviceInfo';
export const DEVICE_CONNECTION_STATUS = '/asset/{0}/device/connectivity/status';
export const DEVICE_SYNCHRONIZE = '/asset/{0}/device/actions/synchronize';
export const UPDATE_DEVICE_SETTING = '/asset/{0}/device/actions/updateSetting';
export const GET_AVAILABLE_FIRMWARE = '/asset/{0}/device/firmwareUpdateAvailability';
export const UPDATE_FIRMWARE = '/asset/{0}/device/updateFirmware';
export const DEVICE_REQUEST_STATUS = '/asset/{0}/device/request-status/{1}';
export const DEVICE_PAIRING = '/device/pairing';
export const USER_CONSENTS = '/user/consents';
export const USER_SUBSCRIPTION_INFO = '/user/subscriptionInfo';
export const USER_CAMPAIGN_TRACKER = '/user/campaignTracker';
export const USER_BADGES = '/user/badges';
export const MESSAGES = '/notifications/messageCenter';
export const EXPERIENCE_INFERENCE_GENERATE = '/asset/{0}/device/actions/device-analytics/TipsTricks';
export const EXPERIENCE_INFERENCE_GET = '/asset/{0}/device/inference/TipsTricks';
export const DEVICE_EXPERIENCE_DATA = '/asset/{0}/device/experience/aggregate-v2/by/{1}';
export const USER_SURVEY = '/user/survey';
export const USER_CONVERSION_STATUS = '/user/conversionStatus';
export const SILENT_FWU_CONFIG = '/asset/{0}/device/silentFwuConfig';
export const USER_CONVERSION_FEEDBACK = '/user/feedback/conversion';
export const USER_APP_FEEDBACK = '/user/feedback/app';
export const RETAIL_DEVICE = '/retail-device';
export const RETAIL_REWARDS = '/retail-rewards';
export const RETAIL_USER_VISIT = '/retail-user-visit';
export const RETAIL_GET_AUTH_TOKEN = '/retail-get-auth-token';
